import Marionette from 'backbone.marionette';
import Navigator from 'app';
import journalCompositviewTmpl from '../templates/journal_event_compositview.tpl';
import JournalEventBillListview from './journal_event_bill_listview';
import JournalEventEmptyview from './journal_event_emptyview';
export default Marionette.CompositeView.extend({
  template: journalCompositviewTmpl,
  childView: JournalEventBillListview,
  emptyView: JournalEventEmptyview,
  childViewContainer: "#daily-events",
  initialize: function () {
    const self = this;
    Navigator.vent.on("event:day:change", function (index) {
      const date = Navigator.days.models[index].get("legislative_day_date");
      console.log("Show bill status changes for:", date);
      const fetchingEvents = Navigator.request("event:daily", date);
      $.when(fetchingEvents).done(function (events) {
        self.collection = events;
        self.render();
      });
    });
  }
});